export default __webpack_public_path__ + "static/letters-galactic-4978c0227714b82ce03cae3d6288432d.png";